module.exports = __webpack_public_path__ + "img/icon-extractor-fan.f42529b9.svg";